module.exports = __webpack_public_path__ + "img/sieckFinesseSetup5.08949db1.png";